import type { IconDefinition } from '@fortawesome/fontawesome-svg-core'

import { ThemeMode } from '@space-core/styles/themes/enum'

import { CustomColorsUtils } from '@space-core/utils/colors'
import styled from 'styled-components'

import BaseAvatar from '../avatar'

type CustomAvatarProps = {
  initialLetters?: string
  urlAvatar?: string
  icon?: IconDefinition
  className?: string
  onClick?: () => void
  customColor?: string
  isLogged?: boolean
  theme?: ThemeMode
}

const getBackgroundColor = ($isLogged?: boolean, $theme?: ThemeMode) => {
  if ($isLogged) {
    return 'var(--custom-color-lightest) !important'
  }

  return $theme === ThemeMode.DARK ? 'var(--white)' : 'var(--gray-900)'
}

const getColor = ($isLogged?: boolean, $customColor?: string, $theme?: ThemeMode) => {
  if ($isLogged) {
    if (CustomColorsUtils.isFixedColor($customColor)) {
      return '_text-gray-900'
    }

    return `${CustomColorsUtils.getBestContrastColor($customColor)} !important`
  }

  return $theme === ThemeMode.DARK ? 'var(--gray-100)' : 'var(--white)'
}

const Avatar = styled(BaseAvatar)<{
  $customColor?: string
  $isLogged?: boolean
  $theme?: ThemeMode
}>`
  background-color: ${({ $isLogged, $theme }) => getBackgroundColor($isLogged, $theme)};
  color: ${({ $isLogged, $customColor, $theme }) => getColor($isLogged, $customColor, $theme)};

  img {
    object-fit: cover;
    height: 100%;
  }
`

const CustomAvatar = ({
  initialLetters,
  urlAvatar,
  icon,
  className,
  onClick,
  customColor,
  isLogged = false,
  theme = ThemeMode.DARK
}: CustomAvatarProps) => {
  return (
    <Avatar
      initialLetters={initialLetters}
      urlAvatar={urlAvatar}
      icon={icon}
      className={className}
      onClick={onClick}
      $customColor={customColor}
      $isLogged={isLogged}
      $theme={theme}
    />
  )
}

export default CustomAvatar
